import { useFormContext, useWatch } from 'react-hook-form';

import { ChangeTaskTypes } from '@xemplo/gp-types';
import { useListBuilder } from '@xemplo/stateful-list-core';
import { V2 } from '@xemplo/text-dropdown';

import { FormFields } from '../../../create-amendment.types';
import * as S from '../../modal.styles';

export function LumpSum() {
  const { control } = useFormContext<FormFields>();
  const changeTask = useWatch({ control, name: 'changeTask' });
  const yesNoList = useListBuilder(YesNoOptions);

  if (changeTask !== ChangeTaskTypes.ALLOWANCE) return null;

  return (
    <S.FormLabel>
      Lump Sum Payments?
      <S.LabelExtraInfo>
        Payments for which the PAYG obligation is spread across multiple pay periods.
        Refer to ATO Schedule 5 - Tax Table for Back Payments, Commissions, Bonuses and
        Similar Payments
      </S.LabelExtraInfo>
      <V2.TextDropdownRhf
        items={yesNoList}
        name="lumpSum"
        placeholder="Select an option"
        data-testid="lumpSum"
        aria-label="Lump sum field"
        rules={{ required: 'This field is required' }}
      />
    </S.FormLabel>
  );
}

export const YesNoOptions = [
  { key: 'No', value: 'No' },
  { key: 'Yes', value: 'Yes' },
];
